export var CONVERGENT_URL = '/customers/products/mobile/profile/#/internet';